/**
 * Formats a provider name for display by capitalizing the first letter of each word
 * and converting dashes to spaces
 * 
 * @param name - The provider name (e.g., "azure-openai", "microsoft-azure")
 * @returns The formatted display name (e.g., "Azure Openai", "Microsoft Azure")
 */
export function formatProviderName(name: string): string {
    if (!name) return '';
    
    return name
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}
